import Vue from 'vue';

export default {
  state: {
    isProfilesLoaded: false,
    profiles: [],
    time: ''
  },
  mutations: {
    SET_PROFILES(state, profiles) {
      state.profiles = profiles;
    },
    ADD_PROFILE(state, profile) {
      state.profiles.push(profile);
    },
    UPDATE_PROFILE(state, {profile, profileIndex}) {
      Vue.set(state.profiles, profileIndex, profile);
    },
    DELETE_PROFILE(state, {profileIndex}) {
      Vue.delete(state.profiles, profileIndex);
    },
    SET_TIME(state, time) {
      state.time = time;
    },
    SET_PROFILES_LOADED(state) {
      state.isProfilesLoaded = true
    }
  },
  actions: {

    async fetchProfiles(context) {
      const response = await Vue.axios.post('/a/myfiles/get_profiles', {prev_time: context.state.time});
      if (response.data.result) {
        context.commit('SET_TIME', response.data.time);
      }
      if (response.data.message && response.data.message.length > 0) {
        for (let i in response.data.message) {
          const profile = response.data.message[i];
          const profileIndex = context.getters.getProfileIndex(profile.id);
          if (profileIndex > -1) {
            context.commit('UPDATE_PROFILE', {profile, profileIndex});
          } else {
            context.commit('ADD_PROFILE', profile);
          }
        }
      }
      if (response.data.result !== false) {
        context.commit('SET_PROFILES_LOADED');
      }
    },

    updateProfileName(context, {profileId, profileName}) {
      return new Promise((resolve, reject) => {
        Vue.axios.post('/ajax/user_slice_rename', {'profile_id': profileId, 'name': profileName}).then(({data}) => {
          if (data.result) {
            const profileIndex = context.getters.getProfileIndex(profileId);
            if (profileIndex > -1) {
              const profile = Object.assign({}, context.state.profiles[profileIndex], {
                name: profileName
              });
              context.commit('UPDATE_PROFILE', {profile, profileIndex});
            }
          }
          resolve(data);
        }).catch(e => {
          reject(e);
        });
      });
    },

    updateProfileEnableState(context, {profileId, enabled}) {
      return new Promise((resolve, reject) => {
        Vue.axios.post('/ajax/user_slice_enable', {'profile_id': profileId, 'enable': enabled}).then(({data}) => {
          if (data.result) {
            //Update enabled status in vuex state
            const profileIndex = context.getters.getProfileIndex(profileId);
            if (profileIndex > -1) {
              const profile = Object.assign({}, context.state.profiles[profileIndex], {
                enabled: enabled ? 't' : 'f'
              });
              context.commit('UPDATE_PROFILE', {profile, profileIndex});
            }
          }
          resolve(data);
        }).catch(e => {
          reject(e);
        })
      });
    },

    updateProfilePriority(context, {profileId, priority}) {
      return new Promise((resolve, reject) => {
        Vue.axios.post('/ajax/user_slice_profile_priority', {'profile_id': profileId, 'priority': priority}).then(({data}) => {
          if (data.result) {
            const profileIndex = context.getters.getProfileIndex(profileId);
            if (profileIndex > -1) {
              const profile = Object.assign({}, context.state.profiles[profileIndex], {
                priority: priority
              });
              context.commit('UPDATE_PROFILE', {profile, profileIndex});
            }
          }
          resolve(data);
        }).catch(e => {
          reject(e);
        });
      });
    },

    deleteProfile(context, profileId) {
      return new Promise((resolve, reject) => {
        Vue.axios.post('/ajax/user_slice_delete', {'profile_id': profileId}).then(({data}) => {
          if (data.result) {
            const profileIndex = context.getters.getProfileIndex(profileId);
            if (profileIndex > -1) {
              const profile = Object.assign({}, context.state.profiles[profileIndex], {
                deleted_by: true
              });
              context.commit('UPDATE_PROFILE', {profile, profileIndex});
            }
          }
          resolve(data);
        }).catch(e => {
          reject(e);
        })
      });
    },

    restoreProfile(context, profileId) {
      return new Promise((resolve, reject) => {
        Vue.axios.post('/ajax/user_slice_restore', {'profile_id': profileId}).then(({data}) => {
          if (data.result) {
            const profileIndex = context.getters.getProfileIndex(profileId);
            if (profileId > -1) {
              const profile = Object.assign({}, context.state.profiles[profileIndex], {
                deleted_by: null,
                deleted_by_email: null
              });
              context.commit('UPDATE_PROFILE', {profile, profileIndex});
            }
          }
          resolve(data);
        }).catch(e => {
          reject(e);
        });
      });
    },

    updateProfileWorkgroupRights(context, {profileId, workgroups}) {
      return Vue.axios.post('/ajax/user_slice_workgroup_enable', {
        'profile_id': profileId,
        'workgroup': workgroups
      });
    },
    
    makeProfileAsDefault(context, {profileId, name}) {
      return Vue.axios.post('/ajax/user_slice_make_default', {'profile_id': profileId, 'name': name});
    }
  },
  getters: {
    getProfileIndex: state => profileId => {
      return state.profiles.findIndex(profile => profile.id === profileId);
    },
    getProfiles: state => {
      return state.profiles;
    },
    isProfilesLoaded: state => {
      return state.isProfilesLoaded;
    }
  }
};
